import { render } from "./FormBase.vue?vue&type=template&id=6bcde770&scoped=true&lang=pug"
import script from "./FormBase.vue?vue&type=script&lang=js"
export * from "./FormBase.vue?vue&type=script&lang=js"

import "./FormBase.vue?vue&type=style&index=0&id=6bcde770&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcde770"]])

export default __exports__